import { render, staticRenderFns } from "./share-data.vue?vue&type=template&id=2ee5df04&scoped=true"
import script from "./share-data.vue?vue&type=script&lang=js"
export * from "./share-data.vue?vue&type=script&lang=js"
import style0 from "./share-data.vue?vue&type=style&index=0&id=2ee5df04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee5df04",
  null
  
)

export default component.exports